  <template>
    <div class="container">
        <loader :active="loading" />

        <header class="jumbotron">
            <div class="info">
                <div class="info-head"><font-awesome-icon icon="tachometer-alt" />
                <h3>Admin</h3></div>
                <small>Poniżej możesz zobaczyć strefy Premium oraz usuwać poszczególne z nich.</small>
            </div>

            <refresh :func="refresh"/>
        </header>

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h5> Strefy </h5>
                    </div>

                    <div class="card-body">
                        <tabs v-if="zones" @changed="tabChanged">
                            <tab v-for="zone in zones" :id="zone.name" :key="zone.name" :name="zone.name" :suffix="'<span class=\'badge badge-danger badge-pill ml-1\'>' + zone.channels.length + '</span>'">
                                <v-client-table v-if="zone.channels.length && !zone.channels[0].a" :key="keyRefresh" :data="zone.channels" :columns="columns" :options="options">
                                    <div slot="options" slot-scope="props">
                                      <button class="btn btn-danger" @click="deleteChannelsZone(props.row.id)">Usuń</button>
                                      <button class="btn btn-warning" @click="changeOwner(props.row.id)">Zmień lidera</button>
                                      <button class="btn btn-info" @click="manageChannel(props.row.id)">Zarządzaj</button>
                                    </div>
                                    <div slot="group" slot-scope="props"><server-groups v-if="props.row.groupInfo" :groups="props.row.groupInfo" with-name/><span v-else>Grupa nie istnieje</span></div>
                                    <client slot="owner" slot-scope="props" :client="props.row.ownerInfo"/>
                                    <div slot="clients" slot-scope="props">{{ props.row.clients.online }} / {{ props.row.clients.sum }}</div>
                                    <div slot="access" slot-scope="props"><client v-for="info in props.row.access" :key="info.dbid" :client="info" badge="warning"><br></client></div>
                                    <span slot="created" slot-scope="props">{{ props.row.created | moment("DD-MM-YYYY HH:mm:ss")}}</span>
                                    <div slot="cids" slot-scope="props"><span v-html="chunkChannels(props.row.cids)"></span></div>
                                </v-client-table>

                                <div class="text-center" v-if="zone.giveChannel">
                                    <button class="btn btn-success" @click="addPremiumChannel(zone.name)"><font-awesome-icon icon="plus" /> Dodaj</button>
                                </div>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AdminService from '../services/admin.service';
    import Vue from "vue";

    export default {
        name: 'Admin',
        data() {
            return {
                loading: true,
                zones: null,
                columns: ['id', 'group', 'owner', 'cids', 'clients', 'access', 'created', 'options'],
                options: {
                    headings: {
                        id: 'ID',
                        group: 'Grupa',
                        owner: 'Założyciel',
                        cids: 'Kanały',
                        clients: 'Klienci online',
                        access: 'Dostęp do panelu',
                        created: 'Data założenia',
                        options: 'Opcje',
                    },
                    sortable: ['id', 'group', 'owner', 'created'],
                    filterable: ['id', 'group', 'owner', 'created', 'access'],
                    texts: window.vueTableLocalize,
                },
                keyRefresh: 1,
                currentTab: ""
            };
        },
        async mounted() {
            await this.refresh(false);
        },
        methods: {
            refresh(clicked = true) {
                return new Promise((resolve, reject) => {
                    this.loading = true;
    
                    AdminService.getZones().then(
                        response => {
                            this.zones = response.data.zones;
                            this.loading = false;
                            if (clicked)
                                this.tabChanged();
                            
                            resolve(true);
                        },
                        error => {
                            this.loading = false;
                            console.log(error);
                            reject(false);
                        }
                    );
                })
            },
            chunkChannels(channels) {
                channels = channels.split(',');
                let i, j, temparray, chunk = 3, toReturn = '';

                for (i=0, j=channels.length; i<j; i+=chunk) {
                    temparray = channels.slice(i,i+chunk);
                    toReturn += temparray.join(',') + '<br>';
                }

                return toReturn;
            },
            tabChanged(e = null) {
                this.loading = true;
                const zoneName = e ? e.tab.id : this.currentTab;
                this.currentTab = zoneName;
                
                AdminService.getSingleZone(zoneName).then(
                    response => {
                        this.zones[zoneName] = response.data.zones[zoneName];
                        this.loading = false;
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
                
                return true;
            },
            manageChannel(id) {
              this.$router.push({name: 'adminManage-manageGroup', params: {id: id}});
            },
            deleteChannelsZone(id) {
                Vue.swal.fire({
                    title: 'Jesteś pewny?',
                    text: "Nie będziesz mógł cofnąć tej operacji!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Tak, usuń!',
                    cancelButtonText: 'Anuluj'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        AdminService.deleteChannelsZone(id).then(
                            () => {
                                this.refresh();

                                Vue.swal.fire({
                                    title: 'Strefa zostanie wkrótce usunięta przez bota!',
                                    text: 'Aby funkcja działała poprawnie, RO-BOT Query musi być włączony.',
                                    icon: 'success',
                                    timer: 6000,
                                    showConfirmButton: true,
                                });
                            },
                            error => {
                                this.loading = false;
                                console.log(error)
                            }
                        );
                    }
                });
            },
            changeOwner(id) {
                Vue.swal.fire({
                    title: 'Wpisz dbid użytkownika',
                    text: 'Upewnij się, że podane DBID jest prawidłowe!',
                    input: 'number',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Zmień',
                    cancelButtonText: 'Anuluj',
                    showLoaderOnConfirm: true,
                    preConfirm: (dbid) => {
                        return AdminService.changeOwner(id, dbid).then(
                            () => {
                                return 'OK';
                            },
                            error => {
                                console.log(error);
                            }
                        );
                    },
                    allowOutsideClick: () => !Vue.swal.isLoading()
                }).then((result) => {
                    if (result.value == 'OK') {
                        this.loading = true;
                        this.refresh();

                        Vue.swal.fire({
                            title: 'Lider kanału został zmieniony!',
                            icon: 'success',
                            timer: 1000,
                            showConfirmButton: false,
                        });
                    }
                })
            },
            addPremiumChannel(zoneName) {
                Vue.swal.fire({
                    title: 'Wpisz dbid użytkownika',
                    text: 'Upewnij się, że podane DBID jest prawidłowe!',
                    input: 'number',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Nadaj',
                    cancelButtonText: 'Anuluj',
                    showLoaderOnConfirm: true,
                    preConfirm: (dbid) => {
                        return AdminService.addPremiumChannel(zoneName, dbid).then(
                            () => {
                                return 'OK';
                            },
                            error => {
                                console.log(error);
                            }
                        );
                    },
                    allowOutsideClick: () => !Vue.swal.isLoading()
                }).then((result) => {
                    if (result.value == 'OK') {
                        this.loading = false;

                        Vue.swal.fire({
                            title: 'Strefa zostanie wkrótce nadana przez bota!',
                            text: 'Aby funkcja działała poprawnie, RO-BOT Query musi być włączony.',
                            icon: 'success',
                            timer: 6000,
                            showConfirmButton: true,
                        });
                    }
                })

            },
        }
    };
</script>
